import React, { lazy } from "react";
import { frontRoutes, frontRoutesColored, frontRoutesWithoutHelpSection, frontRoutesColoredWithoutHelpSection } from "../helpers/front-routes";

// Lazy loading components
const Home = React.lazy(() => import("./components/Home"));
const ContactUsPage = React.lazy(() => import("./components/pages/ContactUsPage"));
const SingleWorkPage = React.lazy(() => import("./components/pages/SingleWorkPage"));
const TemplatesPage = React.lazy(() => import("./components/pages/TemplatesPage"));
const StoresPage = React.lazy(() => import("./components/pages/StoresPage"));
const JobsPage = React.lazy(() => import("./components/pages/JobsPage"));
const SeoPage = React.lazy(() => import("./components/pages/SEOPage"));
const MarketingPage = React.lazy(() => import("./components/pages/MarketingPage"));
const AppsPage = React.lazy(() => import("./components/pages/AppsPage"));
const SchoolsPage = React.lazy(() => import("./components/pages/SchoolsPage"));
const TechnicalSupport = React.lazy(() => import("./components/pages/TechnicalSupport"));
const VPS = React.lazy(() => import("./components/pages/servers/VPSPage"));
const CustomServers = React.lazy(() => import("./components/pages/servers/CustomServers"));
const SharedHosting = React.lazy(() => import("./components/pages/servers/SharedHosting"));
const DedicatedServers = React.lazy(() => import("./components/pages/servers/DedicatedServers"));
const CloudServers = React.lazy(() => import("./components/pages/servers/CloudServers"));
const RestaurantsPage = React.lazy(() => import("./components/pages/RestaurantsPage"));
const MedicalPage = React.lazy(() => import("./components/pages/MedicalPage"));
const WebDesignPage = React.lazy(() => import("./components/pages/WebDesignPage"));
const AcademiesPage = React.lazy(() => import("./components/pages/AcadimiesPage"));
const ServicesPage = React.lazy(() => import("./components/pages/ServicesPage"));
const WorksPage = React.lazy(() => import("./components/pages/WorksPage"));
const PrivacyPage = React.lazy(() => import("./components/pages/PrivacyPage"));
const PaymentsPage = React.lazy(() => import("./components/pages/PaymentsPage"));
const RowaadtosPage = React.lazy(() => import("./components/pages/RowaadTosPage"));

frontRoutes("/", Home);
frontRoutes("/contact-us", ContactUsPage);
frontRoutes("/templates", TemplatesPage);
frontRoutes("/stores", StoresPage);
frontRoutes("/works", WorksPage);
frontRoutes("/services", ServicesPage);
// frontRoutes("/*", NotFoundPage);
frontRoutesColored("/single-work", SingleWorkPage);
frontRoutesColored("/jobs", JobsPage);
frontRoutesColored("/Seo", SeoPage);
frontRoutesColored("/marketing", MarketingPage);
frontRoutesColored("/apps", AppsPage);
frontRoutesColored("/schools", SchoolsPage);
frontRoutesColored("/technicalsupport", TechnicalSupport);
frontRoutesColored("/vps", VPS);
frontRoutesColored("/customservers", CustomServers);
frontRoutesColored("/sharedhosting", SharedHosting);
frontRoutesColored("/dedicatedservers", DedicatedServers);
frontRoutesColored("/cloudservers", CloudServers);
frontRoutes("/rowaad-privacy", PrivacyPage);
frontRoutes("/rowaad-payments", PaymentsPage);
frontRoutes("/rowaad-tos", RowaadtosPage);
frontRoutesWithoutHelpSection("/restaurants", RestaurantsPage);
frontRoutesColoredWithoutHelpSection("/medical", MedicalPage);
frontRoutesColoredWithoutHelpSection("/webdesign", WebDesignPage);
frontRoutesColoredWithoutHelpSection("/acadimies", AcademiesPage);